import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { getGroupedTabs } from './utils';
import {
  NavTab,
  NavTabsWrapper,
  SettingsTabViewContainer,
  SubNavTab,
  SubNavTabsWrapper
} from './styled';
import IconUpOutlined from './IconUpOutlined';

import { keys, values } from '../../util/lodashlike';
const SettingsTabView = ({ tabList, selectedTab, onTabSelect }) => {
  const tabs = getGroupedTabs(tabList);

  const onNavTabSelect = (tab) => {
    let index;
    if (tab.list) {
      if (tab.list[0].list) {
        index = tab.list[0].list[0].index;
      } else {
        index = tab.list[0].index;
      }
    } else {
      index = tab.index;
    }

    onTabSelect(index);
  };

  const selectedNavTab = useMemo(
    () =>
      values(tabs).find((tab) =>
        (tab.indexes ? tab.indexes : [tab.index]).includes(selectedTab)
      ),
    [tabs, selectedTab]
  );

  const checkIsTabSelected = (tab, index) =>
    (tab.indexes ? tab.indexes : [tab.index]).includes(index);

  return (
    <SettingsTabViewContainer>
      <NavTabsWrapper id="settings-nav-tabs">
        {keys(tabs).map((tab) => {
          return (
            <NavTab
              key={tab}
              role="tab"
              className={
                checkIsTabSelected(tabs[tab], selectedTab)
                  ? 'active-nav-tab'
                  : ''
              }
              onClick={() => onNavTabSelect(tabs[tab])}>
              {tab}
              {(tabs[tab].list?.length || 0) > 1 ? (
                <> {<IconUpOutlined />}</>
              ) : null}
            </NavTab>
          );
        })}
      </NavTabsWrapper>

      {(selectedNavTab?.list?.length || 0) > 1 ? (
        <SubNavTabsWrapper id="settings-nav-tabs">
          {selectedNavTab.list.map((tab) => {
            return tab.list ? (
              <SubNavTab
                key={JSON.stringify(tab)}
                role="tab"
                onClick={() => onNavTabSelect(tab.list[0])}
                className={
                  checkIsTabSelected(tab, selectedTab)
                    ? 'active-sub-nav-tab'
                    : ''
                }>
                <span
                  className={
                    checkIsTabSelected(tab, selectedTab)
                      ? 'active-sub-nav-tab-text'
                      : ''
                  }>
                  {tab.list[0].group} {`>`}{' '}
                </span>
                {checkIsTabSelected(tab, selectedTab) ? (
                  <div className="sub-nav-tab-items">
                    {tab.list.map((listItem) => (
                      <span
                        key={listItem.title}
                        role="button"
                        className={
                          checkIsTabSelected(listItem, selectedTab)
                            ? 'active-sub-nav-tab-text'
                            : ''
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onNavTabSelect(listItem);
                        }}>
                        {listItem.title}
                      </span>
                    ))}
                  </div>
                ) : null}
              </SubNavTab>
            ) : (
              <SubNavTab
                key={tab.tab}
                role="tab"
                onClick={() => onNavTabSelect(tab)}
                className={
                  checkIsTabSelected(tab, selectedTab)
                    ? 'active-sub-nav-tab'
                    : ''
                }>
                <span
                  className={
                    checkIsTabSelected(tab, selectedTab)
                      ? 'active-sub-nav-tab-text'
                      : ''
                  }>
                  {tab.tab}
                </span>
              </SubNavTab>
            );
          })}
        </SubNavTabsWrapper>
      ) : null}
    </SettingsTabViewContainer>
  );
};

SettingsTabView.propTypes = {
  tabList: PropTypes.array.isRequired,
  onTabSelect: PropTypes.func.isRequired,
  selectedTab: PropTypes.number.isRequired
};

SettingsTabView.defaultProps = {};

export default SettingsTabView;
